import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { useLabel, useSportsbookFilterUpdate, useSportsbookState } from '@atlas/core';
import { ChipsItem, MobileTimeFilterSkeleton } from '@atlas/ui';

const amountOfHours = [24, 12, 6, 3, 1];
const allTimeName = 'All'; // default value
const reloadDataTime = 3e5; // 5 minutes

const TimeFilter = ({ dateFilterType, filterKey, filterUpdate, timeHours, title }) => {
  const active = useMemo(
    () => (dateFilterType || allTimeName) === filterKey,
    [dateFilterType, filterKey],
  );

  const onClick = useCallback(() => {
    if (active) return;

    filterUpdate({
      dateFilterType: filterKey,
      timeHours,
    });
  }, [active, filterKey, filterUpdate, timeHours]);

  return <ChipsItem active={active} label={title} onClick={onClick} />;
};

const SportsTimeFilter = () => {
  const timeFilter = amountOfHours?.map(hours => ({
    key: `${hours}h`,
    timeHours: hours,
    title: useLabel(`${hours}_h`),
  }));

  timeFilter.unshift({
    key: allTimeName,
    timeHours: null,
    title: useLabel(allTimeName),
  });

  const sportsbookState = useSportsbookState();
  const { filter, filter: { dateFilterType } = {}, initialized, loading } = sportsbookState;

  const resetDirectionClassTimerRef = useRef(null);

  const filterUpdate = useSportsbookFilterUpdate();

  useEffect(() => {
    clearTimeout(resetDirectionClassTimerRef.current);

    // will fetch sportsbook in 5 minutes
    if (filter && filter.timeHours) {
      resetDirectionClassTimerRef.current = setTimeout(() => {
        filterUpdate({ ...filter });
      }, reloadDataTime);
    }
  }, [filter, filterUpdate]);

  if (!initialized && loading) {
    return (
      <div className="chips-list-skeleton">
        <MobileTimeFilterSkeleton />
      </div>
    );
  }

  return (
    <div className="chips-list">
      {timeFilter?.map(({ key, timeHours, title }) => (
        <TimeFilter
          dateFilterType={dateFilterType}
          filterKey={key}
          filterUpdate={filterUpdate}
          key={key}
          timeHours={timeHours}
          title={title}
        />
      ))}
    </div>
  );
};

export default SportsTimeFilter;
